<template>
  <div>
    <div class="text-body-1 mb-2" data-testid="junifer-comm-email-subject">
      <span class="font-weight-medium">Subject:</span> {{ subject }}
    </div>
    <!-- No allow-scripts, allow-popups or allow-top-navigation: the email can't
         run code, open windows or navigate. allow-same-origin only lets us read
         its height to size the frame. -->
    <iframe
      ref="frame"
      :srcdoc="inertHtml"
      :style="{ height: frameHeight }"
      sandbox="allow-same-origin"
      title="Email sent to the customer"
      class="junifer-comm-email-frame"
      data-testid="junifer-comm-email-frame"
      @load="fitToContent"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { toInertEmailHtml } from "@/helpers/emailHtml"

  export default defineComponent({
    props: {
      subject: {
        type: String,
        required: true,
      },
      html: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        frameHeight: "400px",
      }
    },
    computed: {
      inertHtml(): string {
        return toInertEmailHtml(this.html)
      },
    },
    methods: {
      fitToContent() {
        const frame = this.$refs.frame as HTMLIFrameElement | undefined
        const height = frame?.contentDocument?.documentElement.scrollHeight
        if (height) this.frameHeight = `${height}px`
      },
    },
  })
</script>

<style scoped>
  .junifer-comm-email-frame {
    width: 100%;
    border: 1px solid rgb(var(--v-theme-border));
    border-radius: var(--theme-radius);
    background: #fff;
  }
</style>
